import React, { useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { useDispatch } from "react-redux";
import { EditCommandCell } from "../../pages/Settings/GridComponents";
import { toast } from "react-toastify";

const List = ({
  editAction,
  editFormComponent: EditFormComponent,
  loaderComponent: LoaderComponent,
  columns,
  component,
  ...props
}) => {
  const [openForm, setOpenForm] = useState(false);
  const dispatch = useDispatch();
  const [editItem, setEditItem] = useState(null);
  const [gridData, setGridData] = useState([]);

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (event) => {
    try {
      const id = event.activityTypeID ?? event?.timeTypeID;

      if (component === "timeTypes") {
        await dispatch(editAction(id, event));
      } else if (component === "activityTypes") {
        await editAction(id, event);
        toast.success("Activity Type Updated successfully");
      }
    } catch (error) {
      if (component === "activity") {
        toast.error("Update Activity Type failed");
      }
    } finally {
      setOpenForm(false);
    }
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };
  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  const dataReceived = (itemsArray) => {
    setGridData(itemsArray ?? []);
  };

  return (
    <div className="settings-grid">
      <Grid data={gridData}>
        {columns.map((column, index) => (
          <Column key={index} {...column} />
        ))}
        <Column title=" " cell={MyEditCommandCell} width="60" />
      </Grid>

      {openForm && (
        <EditFormComponent
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
        />
      )}

      <LoaderComponent onDataReceived={dataReceived} />
    </div>
  );
};

export default List;
